import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-0 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto w-full col-start-2 md:col-span-6 md:grid-cols-6 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center" }
const _hoisted_5 = { class: "dark:text-gray-400" }
const _hoisted_6 = { class: "pt-16 sm:pt-16 md:pt-5 lg:pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-full" }
const _hoisted_7 = { class: "w-full py-3 md:py-0 sm:pb-10 lg:py-6 max-w-2xl my-2" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full xl:pr-64" }
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "mb-5 pr-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("a", {
  class: "no-underline",
  href: "https://theconcept-technologies.com"
}, " theconcept-technologies.com", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = {
  class: "no-underline",
  href: "mailto:office@boostpack.app"
}
const _hoisted_19 = { class: "mb-5 pr-4" }
const _hoisted_20 = { class: "mb-5" }
const _hoisted_21 = { class: "mb-5" }
const _hoisted_22 = { class: "mb-5" }
const _hoisted_23 = { class: "mb-5" }
const _hoisted_24 = { class: "mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t("imprint.ImprintTitle")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.ImprintNotice")), 1)
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.ImprintDetail")), 1),
                _hoisted_11,
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.CompanyName")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.CompanyStreet")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.CompanyTown")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.CompanyCountry")), 1)
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.CompanyInfo")), 1),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.CompanyWebsiteTitle")), 1),
                  _hoisted_13
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.ObjectTitle")), 1),
                  _hoisted_14,
                  _hoisted_15,
                  _createTextVNode(_toDisplayString(_ctx.$t("imprint.ObjectDetail")), 1)
                ]),
                _hoisted_16,
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.VatTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.VatDetail")), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.GlnTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.GlnDetail")), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.GisaTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.GisaDetail")), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.CoReNuTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.CoReNuDetail")), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.CoReCoTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.CoReCoDetail")), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.CoLoTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.CompanyStreet")), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.MailTitle")), 1),
                  _hoisted_17,
                  _createVNode("a", _hoisted_18, _toDisplayString(_ctx.$t("imprint.MailDetail")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.MemberTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.MemberDetail")), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.SupervisoryTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.SupervisoryDetail")), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.AwardTitle")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("imprint.AwardDetail")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.DataProtectionTitle")), 1)
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.DataProtectionDetail")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.DataProtectionDetail2")), 1)
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.EuTitle")), 1)
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.EuDetail")), 1)
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.LiabilityContentTitle")), 1)
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.LiabilityContentDetail")), 1)
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.LiabilityLinkTitle")), 1)
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.LiabilityLinkDetail")), 1)
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t("imprint.CopyrightTitle")), 1)
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("imprint.CopyrightDetail")), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}